module.exports = __webpack_public_path__ + "static/img/LOGO_7-11.92078b8b.png";